import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { Switch, Radio, FormCheckLabel } from "@smooth-ui/core-sc";
import { Link, withRouter } from "react-router-dom";
import { Block, Divider, Tabs } from "reakit";
import { Box, Card, Flex, Heading, Image, Text, Button } from "rebass";
import {
  Content,
  DesktopBox,
  MobileBox,
  TabHeader,
  MobileHeader,
} from "../../components/Base";
import { SaveButton } from "../../components/Base/Buttons";
import UserList from "../../components/UserList";
import GradeSelect from "../../components/Forms/Grade";
import Customize from "./Customize";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import { EditorState, RichUtils, convertToRaw } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createLinkifyPlugin from "draft-js-linkify-plugin";
import "draft-js/dist/Draft.css";
import "./draft-js-style.css";
import "draft-js-linkify-plugin/lib/plugin.css";
import MdAddCircle from "react-ionicons/lib/MdAddCircle";
import MdFolderOpen from "react-ionicons/lib/MdFolderOpen";
import MdCloseCircle from "react-ionicons/lib/MdCloseCircle";

const linkifyPlugin = createLinkifyPlugin({ target: "_blank" });
const plugins = [linkifyPlugin];

const PageTitle = styled(Heading)`
  font-size: 21px;
  font-weight: 700;
  color: #263039;
  & > span {
    color: #969a9b;
  }
`;

const StyleButton = styled(Button)`
  background-color: white;
  color: black;
  font-weight: 900;
  transition: 0.2s ease;
  padding: 8px;
  margin-right: 4px;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.2;
  ${({ active }) =>
    active &&
    `
		opacity: 1;
	`}
  &:last-child {
    margin-right: 0;
    padding-right: 0;
  }
`;

const UploadButton = styled.label`
  cursor: pointer;
  & > input[type="file"] {
    display: none;
  }

  & > svg {
    display: block;
  }
`;

const AttachmentWrapper = styled(Flex)`
  position: relative;
  border-radius: 4px;
  border: 1px solid black;
  flex-shrink: 0;
  padding: 10px;
  margin: 14px 14px 0 0;
`;

const RemoveButton = styled(MdCloseCircle)`
  cursor: pointer;
  position: absolute;
  top: -12px;
  right: -10px;
`;

const ProgressBar = styled.div`
  margin-bottom: 16px;
  width: 100%;
  height: 14px;
  background-color: #e9ecef;
  border-radius: 20px;
`;

const ProgressBarAnimation = keyframes`
	0% { background-position: 1rem 0; }
	100% { background-position: 0 0; }
`;

const LineBar = styled.div`
  ${({ value }) =>
    value &&
    `
		width: ${value}%;
	`}
  height: 100%;
  animation: ${ProgressBarAnimation} 1s linear infinite;
  background-image: linear-gradient(
    45deg,
    hsla(0, 0%, 100%, 0.15) 25%,
    transparent 0,
    transparent 50%,
    hsla(0, 0%, 100%, 0.15) 0,
    hsla(0, 0%, 100%, 0.15) 75%,
    transparent 0,
    transparent
  );
  background-size: 1rem 1rem;
  background-color: #007bff;
  transition: 0.3s ease;
  border-radius: 14px;
`;

const ClickWrapper = styled(Flex)`
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
`;

const textProps = {
  ml: 3,
};

const INITIAL_STATE = {
  title: "",
  audience: [[], [], [], []],
  locations: [],
  faculty: [],
  is_important: false,
  is_pinned: false,
  editorState: EditorState.createEmpty(),
  fileAttachment: null,
  showBar: false,
  barValue: 0,
  radioAudience: "student",
  audienceFaculty: [[]],
  generalStudent: "All",
  generalFaculty: "All",
};

const TabsContainer = styled(Box)`
  display: none;
  ${({ show }) =>
    show &&
    `
		display: block;
	`}
`;

const NewTabs = styled(Tabs)`
  > li {
    margin: 0;
  }
`;

class NewPost extends Component {
  state = {
    title: "",
    audience: [[], [], [], []],
    locations: [],
    faculty: [],
    is_important: false,
    is_pinned: false,
    selectFaculty: false,
    leaveTypes: "",
    editorState: EditorState.createEmpty(),
    fileAttachment: null,
    showBar: false,
    barValue: 0,
    radioAudience: "student",
    audienceFaculty: [[]],
    generalStudent: "All",
    generalFaculty: "All",
  };

  componentDidMount() {}

  handleEditorChange = (editorState) => {
    this.setState({ editorState });
  };

  handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(
      this.state.editorState,
      command
    );
    if (newState) {
      this.handleEditorChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  handleUnderlineClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "UNDERLINE")
    );
  };

  handleBoldClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "BOLD")
    );
  };

  handleItalicClick = (e) => {
    e.preventDefault();
    this.handleEditorChange(
      RichUtils.toggleInlineStyle(this.state.editorState, "ITALIC")
    );
  };

  handleAudience = (data) => {
    this.setState({ audience: data });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handlePinnedImportant = (name, value) => {
    this.setState({ [name]: value });
  };

  handleAudienceSelect = (name, index) => {
    const { audience } = this.state;
    let contains = false;
    for (var i = audience[index].length - 1; i >= 0; i--) {
      if (audience[index][i] === name) {
        audience[index].splice(i, 1);
        contains = true;
        this.setState({ audience });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      audience[index].push(name);
      this.setState({ audience });
    }
  };

  handleAudienceFaculty = (name, index) => {
    const { audienceFaculty } = this.state;
    let contains = false;
    for (var i = audienceFaculty[index].length - 1; i >= 0; i--) {
      if (audienceFaculty[index][i] === name) {
        audienceFaculty[index].splice(i, 1);
        contains = true;
        this.setState({ audienceFaculty });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      audienceFaculty[index].push(name);
      this.setState({ audienceFaculty });
    }
  };

  handleFacultySelect = (details) => {
    let selected = this.state.faculty;
    console.log("selected for roster", details);
    let contains = false;
    for (var i = selected.length - 1; i >= 0; i--) {
      if (selected[i] === details.id) {
        selected.splice(i, 1);
        contains = true;
        this.setState({ faculty: selected });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      selected.push(details.id);
      this.setState({ faculty: selected });
    }
  };

  handleSwitch = (e) => {
    if (e.target.checked) {
      this.setState({ [e.target.name]: e.target.checked });
    }
  };

  handleSubmit = async () => {
    const { profile, isFaculty, firebase, history } = this.props;
    const {
      title,
      audience,
      is_important,
      is_pinned,
      faculty,
      editorState,
      fileAttachment,
      audienceFaculty,
      generalStudent,
      generalFaculty,
    } = this.state;

    let attachments = [];
    let storageRef = firebase.storage.ref();

    if (fileAttachment != null) {
      this.setState({ showBar: true }, () => this.setState({ barValue: 10 }));
      let progressInc = Number(90 / fileAttachment.length).toFixed(2);
      for (const file of fileAttachment) {
        let name = new Date().getTime() + "-" + file.name;
        let task = await storageRef
          .child(name)
          .put(file, { contentType: file.type });
        let downloadURL = await task.ref.getDownloadURL();
        this.setState((state) => ({
          barValue: Number(state.barValue) + Number(progressInc),
        }));
        attachments.push({
          url: downloadURL,
          name: file.name,
          type: file.type,
          size: this.bytesToSize(file.size),
          fullName: name,
        });
      }
    }

    let newPostRef = this.props.firebase.posts().doc();
    await newPostRef.set({
      creator_is_student: !isFaculty,
      faculty: faculty,
      creator_uid: profile.id,
      has_tags: false,
      is_important,
      is_pinned,
      gender_tag: audience[0],
      grade_tag: audience[1],
      dorm_tag: audience[2],
      status: isFaculty ? 1 : 0,
      title,
      post_time: Math.floor(Date.now() / 1000),
      richMessage: convertToRaw(editorState.getCurrentContent()),
      attachments: attachments,
      gender_faculty: audienceFaculty[0],
      generalStudent,
      generalFaculty,
    });

    this.setState(INITIAL_STATE);
    history.push("/app/home");
  };

  toggleFacultySelect = () => {
    this.setState({ selectFaculty: true });
  };

  editorRef = React.createRef();

  editorFocus = () => {
    this.editorRef.current.focus();
  };

  StyleButtons = (props) => {
    const currentStyle = props.editorState.getCurrentInlineStyle();
    const characters = this.state.editorState.getCurrentContent().getPlainText()
      .length;

    return (
      <Flex justifyContent={"space-between"} alignItems={"center"} mb={3}>
        <Flex alignItems={"center"}>
          <UploadButton htmlFor="postFile">
            <MdAddCircle />
            <input
              type="file"
              id="postFile"
              onChange={this.handleFileChange}
              multiple
            />
          </UploadButton>
          <Text
            ml={2}
            mb={"2px"}
            fontSize={"14px"}
            color={characters > 400 ? "red" : "#969a9b"}
            fontWeight={characters > 400 ? "bold" : "normal"}
          >
            {characters} / 400 characters
          </Text>
        </Flex>
        <Box>
          <StyleButton
            onMouseDown={this.handleBoldClick}
            active={currentStyle.has("BOLD")}
          >
            B
          </StyleButton>
          <StyleButton
            onMouseDown={this.handleItalicClick}
            active={currentStyle.has("ITALIC")}
          >
            I
          </StyleButton>
          <StyleButton
            onMouseDown={this.handleUnderlineClick}
            active={currentStyle.has("UNDERLINE")}
          >
            U
          </StyleButton>
        </Box>
      </Flex>
    );
  };

  handleFileChange = (e) => {
    const { fileAttachment } = this.state;
    e.preventDefault();
    const files = Array.from(e.target.files);

    if (fileAttachment == null) {
      this.setState({
        fileAttachment: files,
      });
    } else {
      this.setState((state) => ({
        fileAttachment: [...state.fileAttachment, ...files],
      }));
    }
  };

  handleDeleteFile = (index) => {
    this.setState((state) => ({
      fileAttachment: state.fileAttachment.filter((_, i) => i !== index),
    }));
  };

  bytesToSize = (bytes, decimals = 1) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1000;
    // const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleRadioChange = (e) => {
    this.setState({
      radioAudience: e.target.value,
    });
  };

  handleSelectGeneral = (type, value) => {
    if (type === "generalFaculty") {
      this.setState({
        audienceFaculty: [[]],
      });
    } else {
      this.setState({
        audience: [[], [], [], []],
      });
    }

    if (this.state[type].length === 0) {
      this.setState({
        [type]: value,
      });
    } else {
      if (this.state[type] === value) {
        this.setState({
          [type]: "",
        });
      } else {
        this.setState({
          [type]: value,
        });
      }
    }
  };

  render() {
    const { dormList, locations, audience, selectFaculty } = this.state;
    const { isFaculty, school, faculty } = this.props;
    const {
      editorState,
      fileAttachment,
      showBar,
      barValue,
      radioAudience,
      audienceFaculty,
      generalStudent,
      generalFaculty,
    } = this.state;

    const messageLength = editorState.getCurrentContent().getPlainText().length;

    let customizeReady = false;
    if (
      messageLength > 0 &&
      messageLength <= 400 &&
      (generalStudent !== "None" || generalFaculty !== "None")
    ) {
      customizeReady = true;
    }

    let disableSubmit = true;

    if (
      messageLength > 0 &&
      messageLength <= 400 &&
      (generalStudent !== "None" || generalFaculty !== "None")
    ) {
      disableSubmit = false;
    }

    return (
      <Box>
        <MobileHeader>
          <Text fontWeight={"bold"} fontSize={"24px"} mb={3}>
            New Post
          </Text>
        </MobileHeader>

        {!selectFaculty ? (
          <Content>
            <Flex flexDirection={["column", "row"]} flexWrap={"wrap"}>
              <Box width={[1, 1 / 2]} p={[3, "48px"]}>
                <DesktopBox>
                  <Box mb={4}>
                    <SaveButton
                      disabled={disableSubmit}
                      onClick={
                        isFaculty ? this.handleSubmit : this.toggleFacultySelect
                      }
                      bg={disableSubmit ? "gray" : "purple"}
                      mr={2}
                    >
                      {isFaculty ? "Save" : "Next"}
                    </SaveButton>
                    <Link to={"/app/home"}>
                      <SaveButton bg={"metaText"}>Discard</SaveButton>
                    </Link>
                  </Box>
                </DesktopBox>
                <Box mb={3}>
                  <this.StyleButtons editorState={editorState} />
                  <Box onClick={this.editorFocus} className="post-editor">
                    <Editor
                      editorState={editorState}
                      onChange={this.handleEditorChange}
                      handleKeyCommand={this.handleKeyCommand}
                      placeholder="Type your announcement"
                      ref={this.editorRef}
                      plugins={plugins}
                    />
                  </Box>
                </Box>

                {showBar && (
                  <ProgressBar>
                    <LineBar value={barValue} />
                  </ProgressBar>
                )}

                <Flex flexWrap={"wrap"}>
                  {fileAttachment != null &&
                    fileAttachment.map((file, index) => (
                      <AttachmentWrapper key={index} alignItems={"center"}>
                        <MdFolderOpen
                          style={{ marginRight: "10px", flexShrink: 0 }}
                          fontSize="28px"
                        />
                        <Box>
                          <Heading fontSize={"16px"}>
                            {file.name.length > 30
                              ? file.name.slice(0, 26) + "..."
                              : file.name}{" "}
                            ({this.bytesToSize(file.size)})
                          </Heading>
                          <Text fontSize={"14px"}>{file.type}</Text>
                        </Box>
                        <RemoveButton
                          onClick={() => {
                            this.handleDeleteFile(index);
                          }}
                        />
                      </AttachmentWrapper>
                    ))}
                </Flex>
              </Box>
              <Box width={[1, 1 / 2]}>
                <MobileBox>
                  <Customize
                    {...this.props}
                    handleSubmit={this.handleSubmit}
                    handlePinned={this.handlePinnedImportant}
                    ready={customizeReady}
                    dorms={dormList}
                    locations={locations}
                    faculty={faculty}
                    handleAudience={this.handleAudience}
                    radioAudience={radioAudience}
                    handleRadioChange={this.handleRadioChange}
                    handleAudienceFaculty={this.handleAudienceFaculty}
                    audienceFaculty={JSON.parse(
                      JSON.stringify(this.state.audienceFaculty)
                    )}
                    handleSelectGeneral={this.handleSelectGeneral}
                    generalStudent={JSON.parse(
                      JSON.stringify(this.state.generalStudent)
                    )}
                    generalFaculty={JSON.parse(
                      JSON.stringify(this.state.generalFaculty)
                    )}
                  />
                </MobileBox>
                <DesktopBox>
                  <Flex flexDirection={"row"}>
                    <Box
                      width={1 / 2}
                      p={[3, "48px"]}
                      pl={[3, 0]}
                      pt={[3, "86px"]}
                    >
                      <PageTitle mb={"20px"}>
                        Audience
                        <Flex
                          mt={2}
                          alignItems={"center"}
                          justifyContent={"flex-start"}
                        >
                          <Flex mr={3}>
                            <Radio
                              size="sm"
                              id="studentRadio"
                              value="student"
                              onChange={this.handleRadioChange}
                              checked={radioAudience === "student"}
                            />
                            <FormCheckLabel
                              fontSize={"16px"}
                              color={"metaText"}
                              htmlFor="studentRadio"
                            >
                              Student
                            </FormCheckLabel>
                          </Flex>
                          <Flex>
                            <Radio
                              size="sm"
                              id="facultyRadio"
                              value="faculty"
                              onChange={this.handleRadioChange}
                              checked={radioAudience === "faculty"}
                            />
                            <FormCheckLabel
                              fontSize={"16px"}
                              color={"metaText"}
                              htmlFor="facultyRadio"
                            >
                              Faculty
                            </FormCheckLabel>
                          </Flex>
                        </Flex>
                      </PageTitle>
                      <TabsContainer show={radioAudience === "student"}>
                        <Tabs.Container>
                          {(tabs) => (
                            <Block>
                              <NewTabs>
                                <Tabs.Tab tab="general" {...tabs}>
                                  <TabHeader title={"General"} />
                                </Tabs.Tab>
                                <Tabs.Tab
                                  tab="dorm"
                                  {...tabs}
                                  disabled={generalStudent.length !== 0}
                                  style={{
                                    opacity:
                                      generalStudent.length !== 0 && "0.4",
                                  }}
                                >
                                  <TabHeader title={"Dorm"} />
                                </Tabs.Tab>
                                <Tabs.Tab
                                  tab="gender"
                                  {...tabs}
                                  disabled={generalStudent.length !== 0}
                                  style={{
                                    opacity:
                                      generalStudent.length !== 0 && "0.4",
                                  }}
                                >
                                  <TabHeader title={"Gender"} />
                                </Tabs.Tab>
                                <Tabs.Tab
                                  tab="grade"
                                  {...tabs}
                                  disabled={generalStudent.length !== 0}
                                  style={{
                                    opacity:
                                      generalStudent.length !== 0 && "0.4",
                                  }}
                                >
                                  <TabHeader title={"Grade"} />
                                </Tabs.Tab>
                              </NewTabs>
                              <Tabs.Panel tab="dorm" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <Divider />
                                  {school.dorms.map((dorm) => (
                                    <Box width={1}>
                                      <ClickWrapper
                                        key={dorm.id}
                                        onClick={() =>
                                          this.handleAudienceSelect(dorm.id, 2)
                                        }
                                      >
                                        <Box>
                                          <Text {...textProps}>
                                            {dorm.name}
                                          </Text>
                                        </Box>
                                        <Box ml={"auto"} />
                                        <Box pr={2}>
                                          {audience[2].includes(dorm.id) && (
                                            <Image src={check} />
                                          )}
                                        </Box>
                                      </ClickWrapper>
                                      <Divider />
                                    </Box>
                                  ))}
                                </Card>
                              </Tabs.Panel>
                              <Tabs.Panel tab="general" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleSelectGeneral(
                                        "generalStudent",
                                        "All"
                                      )
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="all">
                                        All
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {generalStudent === "All" && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleSelectGeneral(
                                        "generalStudent",
                                        "None"
                                      )
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="none">
                                        None
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {generalStudent === "None" && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                </Card>
                              </Tabs.Panel>
                              <Tabs.Panel tab="gender" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleAudienceSelect("F", 0)
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="male">
                                        Female
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {audience[0].includes("F") && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleAudienceSelect("M", 0)
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="male">
                                        Male
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {audience[0].includes("M") && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                </Card>
                              </Tabs.Panel>
                              <Tabs.Panel tab="grade" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <GradeSelect
                                    handleSelect={this.handleAudienceSelect}
                                    audience={audience}
                                  />
                                </Card>
                              </Tabs.Panel>
                            </Block>
                          )}
                        </Tabs.Container>
                      </TabsContainer>
                      <TabsContainer show={radioAudience === "faculty"}>
                        <Tabs.Container>
                          {(tabs) => (
                            <Block>
                              <NewTabs>
                                <Tabs.Tab tab="general" {...tabs}>
                                  <TabHeader title={"General"} />
                                </Tabs.Tab>
                                <Tabs.Tab
                                  tab="gender"
                                  {...tabs}
                                  disabled={generalFaculty.length !== 0}
                                  style={{
                                    opacity:
                                      generalFaculty.length !== 0 && "0.4",
                                  }}
                                >
                                  <TabHeader title={"Gender"} />
                                </Tabs.Tab>
                              </NewTabs>
                              <Tabs.Panel tab="general" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleSelectGeneral(
                                        "generalFaculty",
                                        "All"
                                      )
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="all">
                                        All
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {generalFaculty === "All" && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleSelectGeneral(
                                        "generalFaculty",
                                        "None"
                                      )
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="none">
                                        None
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {generalFaculty === "None" && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                </Card>
                              </Tabs.Panel>
                              <Tabs.Panel tab="gender" {...tabs}>
                                <Card mt={"28px"} boxShadow={"inset"}>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleAudienceFaculty("F", 0)
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="male">
                                        Female
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {audienceFaculty[0].includes("F") && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                  <ClickWrapper
                                    onClick={() =>
                                      this.handleAudienceFaculty("M", 0)
                                    }
                                  >
                                    <Box>
                                      <Text {...textProps} name="male">
                                        Male
                                      </Text>
                                    </Box>
                                    <Box ml={"auto"} />
                                    <Box pr={2}>
                                      {audienceFaculty[0].includes("M") && (
                                        <Image src={check} />
                                      )}
                                    </Box>
                                  </ClickWrapper>
                                  <Divider />
                                </Card>
                              </Tabs.Panel>
                            </Block>
                          )}
                        </Tabs.Container>
                      </TabsContainer>
                    </Box>
                    <Box
                      width={1 / 2}
                      p={[3, "48px"]}
                      pl={[3, 0]}
                      pt={[3, "86px"]}
                    >
                      {isFaculty && (
                        <Card mt={2}>
                          <Flex mt={4} justifyContent={"space-between"} mb={1}>
                            <Box>
                              <Heading>Pin</Heading>
                            </Box>
                            <Box>
                              <Switch
                                name={"is_pinned"}
                                onChange={this.handleSwitch}
                              />
                            </Box>
                          </Flex>
                          <Text color={"metaText"}>
                            By switching on the switch, your post will be pinned
                            at the top of the post feed.
                          </Text>
                          <Flex mt={4} justifyContent={"space-between"} mb={1}>
                            <Box>
                              <Heading>Important</Heading>
                            </Box>
                            <Box>
                              <Switch
                                name="is_important"
                                onChange={this.handleSwitch}
                              />
                            </Box>
                          </Flex>
                          <Text color={"metaText"}>
                            By switching on the switch, all students will be
                            notified of this post.
                          </Text>
                        </Card>
                      )}
                    </Box>
                  </Flex>
                </DesktopBox>
              </Box>
            </Flex>
          </Content>
        ) : (
          <Content>
            <Box mb={4}>
              <SaveButton
                disabled={this.state.faculty.length === 0}
                onClick={this.handleSubmit}
                m={1}
                bg={this.state.faculty.length === 0 ? "gray" : "purple"}
              >
                Save
              </SaveButton>
              <Link to={"/app/home"}>
                <SaveButton m={1} bg={"metaText"}>
                  Discard
                </SaveButton>
              </Link>
            </Box>
            <Heading>Invite at least one faculty member</Heading>
            <UserList
              students={faculty}
              selected={this.state.faculty}
              handleUserClick={this.handleFacultySelect}
            />
          </Content>
        )}
      </Box>
    );
  }
}

export default withRouter(NewPost);
